export default "/assets/images/critter-cuddler2.png?018ca9a0e642fc08ef2836f5935fc7e7";